"use strict";
import React from "react";
import { getCustomerNameDisplay } from "../customerNameDisplay";
function loadShipmentText(loadShipment) {
  const customerName = loadShipment.customer_name ? getCustomerNameDisplay(
    loadShipment.customer_name,
    loadShipment.customer_external_id
  ) : "(Missing Customer)";
  if (loadShipment.state === "Approved") {
    return `${customerName} - Approved`;
  } else if (loadShipment.approvable) {
    return `${customerName} - Ready to Bill`;
  } else {
    return `${customerName} - Billing exceptions`;
  }
}
function submitResolveExceptions(props, e) {
  e.preventDefault();
  props.confirmMessageOrException();
}
function AuditBillingConfirmationButtons(props) {
  if (props.isApprovable) {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        "data-component": "AuditBillingConfirmationButtons",
        className: "audit-billing-confirmation__approve-section"
      },
      /* @__PURE__ */ React.createElement("button", { className: "button--progress", onClick: props.approve }, "Save and Approve")
    );
  } else {
    return /* @__PURE__ */ React.createElement("form", { onSubmit: (e) => submitResolveExceptions(props, e) }, /* @__PURE__ */ React.createElement("div", { className: "audit-billing-confirmation__buttons" }, /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement("h6", null, "Resolve Exceptions by:"), /* @__PURE__ */ React.createElement("div", { className: "audit-billing-confirmation__radio-button" }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "radio",
        id: "sendMessage",
        name: "MessageOrException",
        checked: props.messageOrException === "sendMessage",
        onChange: props.handleMessageOrException,
        value: "sendMessage"
      }
    ), /* @__PURE__ */ React.createElement("label", { htmlFor: "sendMessage" }, "Send Message")), /* @__PURE__ */ React.createElement("div", { className: "audit-billing-confirmation__radio-button" }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "radio",
        id: "saveException",
        name: "MessageOrException",
        checked: props.messageOrException === "saveException",
        onChange: props.handleMessageOrException,
        value: "saveException"
      }
    ), /* @__PURE__ */ React.createElement("label", { htmlFor: "saveException" }, "Save Exception"), /* @__PURE__ */ React.createElement("br", null))), /* @__PURE__ */ React.createElement("button", { onClick: (e) => submitResolveExceptions(props, e) }, "Confirm")));
  }
}
function allApprovable(props) {
  const loadShipments = props.load.load.tms_load_shipments;
  const approvableloadShipments = loadShipments.every(
    (loadShipment) => !!loadShipment.approvable
  );
  return props.carrierInvoice.approvable && approvableloadShipments;
}
function paymentText(props) {
  if (props.carrierInvoice.state === "partial_approved") {
    return `${props.carrier.name} - Approved`;
  } else if (props.carrierInvoice.approvable) {
    return `${props.carrier.name} - Ready to Pay`;
  } else {
    return `${props.carrier.name} - Payment exceptions`;
  }
}
function statusTexts(props) {
  const loadShipmentTexts = props.load.load.tms_load_shipments.map(loadShipmentText).join(", ");
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { className: "audit-billing-confirmation__status" }, loadShipmentTexts, ",", " "), /* @__PURE__ */ React.createElement("span", { className: "audit-billing-confirmation__status" }, paymentText(props)));
}
function AuditBillingConfirmation(props) {
  const confirmMessageOrException = () => {
    if (props.messageOrException === "sendMessage") {
      props.handleSendMessage();
    } else if (props.messageOrException === "saveException") {
      props.handleSaveException();
    }
  };
  const approve = () => {
    props.handleApprove(props.payment, true);
  };
  return /* @__PURE__ */ React.createElement("div", { className: " audit-billing-confirmation" }, /* @__PURE__ */ React.createElement("div", { className: "audit-billing-confirmation__status_header" }, "Status:"), statusTexts(props), /* @__PURE__ */ React.createElement(
    AuditBillingConfirmationButtons,
    {
      isApprovable: allApprovable(props),
      messageOrException: props.messageOrException,
      handleMessageOrException: props.handleMessageOrException,
      confirmMessageOrException,
      approve
    }
  ));
}
export default AuditBillingConfirmation;
